import { deactivateActiveAudioNodeInputConnections } from './deactivate-active-audio-node-input-connections';
export const deactivateAudioGraph = (context) => {
    deactivateActiveAudioNodeInputConnections(context.destination, []);
};
//# sourceMappingURL=deactivate-audio-graph.js.map